export const checkInitialValuesEmpty = (scheduleData) => Object.keys(scheduleData).filter((key) =>
  key !== 'policyAndTermCheckbox'
    ? Object.keys(scheduleData[key]).every((childKey) =>
      typeof scheduleData[key][childKey] === 'string'
        ? !scheduleData[key][childKey]
        : !scheduleData[key][childKey]?.length
    )
    : false
);